import { MoreVerticalIcon, Trash2 } from "lucide-react";
import { useState } from "react";

import { useGetAuthUser } from "@/api/get-user";
import { Button } from "@/components/ui/button";
import { Dialog } from "@/components/ui/dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { PublicPlaylist } from "@classview/shared-types";

import { DeletePlaylistModal } from "./delete-playlist-modal";

type PlaylistItemActionsProps = {
  playlist: PublicPlaylist;
};

export function PlaylistItemActions(props: PlaylistItemActionsProps) {
  const [modalType, setModalType] = useState<"delete" | null>(null);
  const { data: user } = useGetAuthUser();

  const isOwner = user?.sub === props.playlist.ownerId;

  if (!isOwner) {
    return null;
  }

  return (
    <Dialog open={!!modalType} onOpenChange={() => setModalType(null)}>
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon">
            <MoreVerticalIcon className="size-4" aria-hidden={true} />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem
            className="text-destructive"
            onClick={() => setModalType("delete")}
          >
            <Trash2 className="size-4" aria-hidden={true} /> Delete Playlist
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      {modalType === "delete" && (
        <DeletePlaylistModal playlistId={props.playlist.id} />
      )}
    </Dialog>
  );
}
